import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import logo from '../assets/logo.png'

export default function AuthLayout() {
  const { user } = useAuthStore()

  // If user is already logged in, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark flex relative overflow-hidden">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-white dark:bg-surface-dark p-12 flex-col justify-between border-r border-gray-200 dark:border-gray-800">
        <div className="absolute inset-0 dot-pattern opacity-40"></div>
        
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-12">
            <img src={logo} alt="ProofFlow" className="w-10 h-10 object-contain" />
            <span className="font-bold text-2xl text-gray-900 dark:text-white">ProofFlow</span>
          </div>
          
          <div className="max-w-md">
            <div className="text-4xl mb-4">"</div>
            <blockquote className="text-2xl lg:text-3xl font-display font-medium leading-snug text-gray-900 dark:text-white mb-8">
              ProofFlow transformed our review process. We went from endless email threads to getting approvals in hours, not days.
            </blockquote>
            <div className="flex items-center gap-4">
              <img
                alt="Sarah Jenkins"
                className="w-12 h-12 rounded-full border-2 border-gray-100 dark:border-gray-700 object-cover"
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop"
              />
              <div>
                <div className="font-semibold text-gray-900 dark:text-white">Sarah Jenkins</div>
                <div className="text-sm text-muted-light dark:text-muted-dark">Creative Director, Apex Studio</div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700 dark:text-gray-300 font-medium">14-day free trial</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700 dark:text-gray-300 font-medium">No credit card required</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700 dark:text-gray-300 font-medium">Cancel anytime</span>
            </div>
          </div>
        </div>

        {/* Floating elements for visual interest */}
        <div className="absolute top-20 right-12 animate-float-slow opacity-60">
          <img
            src="https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=200&auto=format&fit=crop"
            alt="3D Element"
            className="w-24 h-24 rounded-full shadow-glow"
          />
        </div>
        <div className="absolute bottom-32 right-24 animate-float-medium opacity-50">
          <img
            src="https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?q=80&w=200&auto=format&fit=crop"
            alt="3D Element"
            className="w-32 h-32 rounded-full shadow-glow"
          />
        </div>
      </div>

      {/* Right side - Auth forms */}
      <div className="flex-1 flex items-center justify-center p-8 relative">
        <div className="absolute inset-0 dot-pattern opacity-30"></div>
        <div className="w-full max-w-md relative z-10">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
